import React, { useState, useEffect, useRef, use ,useCallback } from 'react';
import ProfilerNavBar from '../profilerEditingPage/profilerNavBar';
import Sidebar from "./sideBar";
import JobList from './jobList';
import webSocketParserService from '../../../services/webSocketSingleConnectionService';
import { FiCheckCircle, FiLoader } from 'react-icons/fi';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { mockApiResponse } from "../../../data/mockJobsApiResponse";
import { useToast } from '../../../common/toastSystem';
import { resumeUpload } from "../../../supports/resumeUpload";
import ProfilerEditingPage from '../profilerEditingPage/profilerEditingPage';
import Loader from "../../../common/loader";
import { generateRequestId, MANDATORY_FIELDS,ALL_PROFILE_FIELDS,COMPLETION_FIELDS  } from '../../../common/common';
import unifiedAuthManager from '../../../services/unifiedAuthManager';
import { filter, set } from 'lodash';


// function isFilled(value) {
//   if (value === null || value === undefined) return false;
//   if (typeof value === "string") return value.trim() !== "";
//   if (Array.isArray(value)) return value.length > 0;
//   if (typeof value === "object") return Object.keys(value).length > 0;
//   return !!value;
// }

// function calculateCompletionPercentage(profileDetails) {
//   if (!profileDetails) return 0;
//   let filled = 0;
//   let total = MANDATORY_FIELDS.length;

//   for (const field of MANDATORY_FIELDS) {
//     if (field === "education" || field === "experience" || field === "skills") {
//       if (isFilled(profileDetails[field])) filled++;
//     } else {
//       if (isFilled(profileDetails[field])) filled++;
//     }
//   }
//   return Math.round((filled / total) * 100);
// }

function isFilled(value) {
  if (value === null || value === undefined) return false;
  if (typeof value === "string") return value.trim() !== "";
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === "object") return Object.keys(value).length > 0;
  return !!value;
}

// Check experience: at least one entry with title, company, start_date, end_date (or currentlyWorking)
function isExperienceValid(experience_intervals) {
  if (!Array.isArray(experience_intervals) || experience_intervals.length === 0) return false;
  return experience_intervals.some(exp =>
    isFilled(exp.title) && 
    isFilled(exp.company) &&
    isFilled(exp.start_date || exp.startDate) &&
    (isFilled(exp.end_date || exp.endDate) || exp.currentlyWorking === true)
  );
}

// Check education: at least one entry with degree, institution, year of passing, year of study
function isEducationValid(education_details) {
  
  if (!Array.isArray(education_details) || education_details.length === 0) return false;
  return education_details.some(edu =>
    isFilled(edu.degree) &&
    isFilled(edu.institution) 
    // isFilled(edu.duration_text || edu.year_of_completion) 
  );
}

export function getFullProfileReport(profileDetails) {
  if (!profileDetails) return [];

  return COMPLETION_FIELDS.map(({ key, label, section }) => {
    let filled = false;
    if (key === 'experience_intervals') {
      filled = isExperienceValid(profileDetails[key]);
    } else if (key === 'education_details') {
      filled = isEducationValid(profileDetails[key]);
    } else if (key === 'date_of_birth') {
      // Consider filled if disclosed (do not disclose) OR has a value
      filled = profileDetails.dob_disclosed === true || isFilled(profileDetails[key]);
    } else if (key === 'nationality') {
      // Consider filled if disclosed OR has a value
      filled = profileDetails.nationality_disclosed === true || isFilled(profileDetails[key]);
    } else if (key === 'location') {
      // Handle location object with id === 'Nil'
      const loc = profileDetails[key];
      if (loc && typeof loc === 'object') {
        filled = loc.id !== 'Nil' && isFilled(loc);
      } else {
        filled = isFilled(loc);
      }
    } else {
      filled = isFilled(profileDetails[key]);
    }

    return { key, label, section, filled, value: profileDetails[key] };
  });
}

export function calculateCompletionPercentage(profileDetails) {
  const report = getFullProfileReport(profileDetails);
  console.log('Full Profile Report:', report);
  const filled = report.filter(f => f.filled).length;
  return {
    percentage: Math.round((filled / report.length) * 100),
    filled,
    total: report.length,
    report,
    missing: report.filter(f => !f.filled),
  };
}

const ParsingProgressView = ({ messages, warning, title }) => (
  <div className="flex justify-center items-center">
    <div className="h-full w-1/2 text-left p-8 bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg">
      <h3 className="font-bold text-xl mb-4 mph-primary flex items-center gap-2">
        <FiLoader className="animate-spin" /> {title}
      </h3>
      {messages.length > 0 ? (
        <ul className="space-y-3">
          {messages.map((msg, index) => (
            <li key={index} className="flex items-center gap-3 text-sm text-gray-700 animate-fade-in">
              <FiCheckCircle className="mph-primary flex-shrink-0" />
              <span>{msg}</span>
            </li>
          ))}
        </ul>
      ) : (
        <div className="text-grey-666 text-sm mt-4 flex items-center gap-2">
          <span>{warning}</span>
        </div>
      )}
    </div>
  </div>
);

function JobRecommendationsPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const toast = useToast();

  const resume_Id = searchParams.get('resumeId');
  const [resumeId, setResumeId] = useState(resume_Id || null);
     const [userCandidateId, setUserCandidateId] = useState(searchParams.get('candidateId'));
        const isAuthed = unifiedAuthManager.isAuthenticated();

  const [pageState, setPageState] = useState('loading'); // 'loading' | 'parsing' | 'success' | 'error' | 'failed'
  const pageStateRef = useRef(pageState);
  const setPageStateSafe = (s) => {
    pageStateRef.current = s;
    setPageState(s);
  };

  const [pageData, setPageData] = useState(null);
  const pageDataRef = useRef(pageData);
  const setPageDataSafe = (d) => {
    pageDataRef.current = d;
    setPageData(d);
  };

  const [candidateId, setCandidateId] = useState('');
  const [progressMessages, setProgressMessages] = useState([]);
   const [allUserJobs, setAllUserJobs] = useState([]);
    const [appliedJobs, setAppliedJobs] = useState([]);
    const [currentJobs, setCurrentJobs] = useState([]);
     const [isLoading, setIsLoading] = useState(false);
       const [isMorePage, setIsMorePage] = useState(false);
          const[currentMenu,setCurrentMenu]=useState('All')

  const [showResumeEditor, setShowResumeEditor] = useState(false);
  const [completionPercentage, setCompletionPercentage] = useState(0);
    const user = unifiedAuthManager.getUnifiedUser();
    const[pageCount,setPageCount]=useState(1)
    const[modalMessage,setModalMessage]=useState('Only registered candidates can apply. Please continue to register.')
    const[isregister,setIsRegister]=useState(false)
const[onregister,setOnRegister]=useState(false)
  const[isSend,setIsSend]=useState(false)
const [applyingJobId, setApplyingJobId] = useState(null);
const[moreJobs,setMoreJobs]=useState(false) 
const[allSectors,setAllSectors]=useState([])
const[allCountries,setAllCountries]=useState([])
const[registrationPassword, setRegistrationPassword] = useState('')
const[registrationPasswordConfirm, setRegistrationPasswordConfirm] = useState('')
const[passwordError, setPasswordError] = useState('')
const [filteredSectors, setFilteredSectors] = useState([]);
const [filteredCountries, setFilteredCountries] = useState([]);
const [filteredJobs, setFilteredJobs] = useState([]);
const [searchQuery, setSearchQuery] = useState('');
const [totalJobs, setTotalJobs] = useState(0);
const [count, setCount] = useState(1);

const [isTabApiCalling, setIsTabApiCalling] = useState(false)




  useEffect(() => {
    fetchAllSectors()
    fetchAllCountries()
    // if(isAuthed && !userCandidateId){
    //   setUserCandidateId(resumeId);
    // }
  },[]);


    const fetchAllSectors=async()=>{
    try {
      console.log('inside sectors',user)
      let payload= {
        user_payload:{
            request_id: generateRequestId(),

        }
    }
        let response=await resumeUpload.jobSectors(payload)
        setAllSectors(response.data)
        console.log('sectors',response) 
    } catch (error) {
      console.log(error)
    }
  }

  const fetchAllCountries=async()=>{
    try {
      console.log('inside sectors',user)
      let payload= {
        user_payload:{
            request_id: generateRequestId(),
        }
    }
        let response=await resumeUpload.jobCountries(payload)
        setAllCountries(response.data)
        console.log('countries',response) 
    } catch (error) {
      console.log(error)
    }
  }

  //   const setSuccessWithData = (data) => {
  //   setPageDataSafe(data);
  //   if (data && data.profile_details) {
  //     const percent = calculateCompletionPercentage(data.profile_details);
  //     setCompletionPercentage(percent);
  //   } else {
  //     setCompletionPercentage(0);
  //   }
  //   setPageStateSafe('success');
  // };

const setSuccessWithData = (data) => {
  setPageDataSafe(data);
  if (data && data.profile_details) {
    const fullReport = calculateCompletionPercentage(data.profile_details);
    console.table(fullReport.report);
    console.log('Missing:', fullReport.missing.map(f => f.label));
    setCompletionPercentage(fullReport.percentage); // ✅ number only
  } else {
    setCompletionPercentage(0);
  }
  setPageStateSafe('success');
};
   const onApplyJob = async (job) => {
    try {
      console.log('applying job',job) 
       setApplyingJobId(job.id);

      if(!userCandidateId){
        //  createUser()
        setIsRegister(true)
      }
      else if(userCandidateId && !pageData.validation.all_present){
        toast.warning('Please add the missing details to apply')
      }
      else{
//               currentJobs.forEach(jobs => {
//   if (jobs.id === job.id) {
//     jobs.apply = true;
//   }
// });

// setCurrentJobs(currentJobs)
     applyjob(job)
      }

     console.log("Applying to job:", user);
    } catch (error) {
      console.log(error);

    }
  }

const handleCountChange = (value) => {
  if(value != undefined){
    console.log('makecall1')
      // setPageCount(value)
    if(currentMenu === 'Recommended'){
     fetchRecommendedJobs(value, searchQuery);
    }else if(currentMenu === 'All'){
        setMoreJobs(true)
    fetAllJobs(value, pageData.profile_details.email, {
      sectors: filteredSectors,
      countries: filteredCountries
    }, searchQuery);
    }
  
  }
};

  const applyjob = async(job)=>{
    try {
  console.log('applied',job)

      let requestBody={
         job_id:job.id,
    user_payload: {
        request_id: generateRequestId(),
        user_id:parseInt(user.id)
    }
      }
          let response=await resumeUpload.applyJobs(requestBody)
          if(response.status_code==200){
           if(currentMenu !== 'Recommended'){  
  console.log('makecall2')
  // Create a new array with updated job object
  const updatedJobs = currentJobs.map(jobs => 
    jobs.id === job.id 
      ? { ...jobs, application_status: "APPLIED" } 
      : jobs
  );
  console.log('makecall3')
  setCurrentJobs(updatedJobs) // ✅ New array reference
}
  else{
    setCurrentJobs(currentJobs.filter(jobs => jobs.id !== job.id))
  }

            toast.success(response.message)
          }else{
            toast.error(response.message)
          }
          console.log('jop application',response)
    } catch (error) {
      console.log(error);

    }
  }


   const createUser=async()=>{
    try {
      // Validate password
      if (!registrationPassword || !registrationPasswordConfirm) {
        setPasswordError('Both password fields are required');
        return;
      }
      
      if (registrationPassword.length < 8) {
        setPasswordError('Password must be at least 8 characters long');
        return;
      }
      
      if (registrationPassword !== registrationPasswordConfirm) {
        setPasswordError('Passwords do not match');
        return;
      }
      
      setPasswordError('');
      setOnRegister(true)
       setModalMessage('Registration in progress')
      let response = await resumeUpload.createCandidateUser({
        'email':pageData.profile_details.email,
        'first_name': pageData.profile_details.first_name,
        'last_name': pageData.profile_details.last_name,
        'password': registrationPassword
      })
      if(response.status_code==200){
        // setModalMessage('Check your email to verify your account.')
         setModalMessage('An email has been sent to your inbox. If you do not receive it, please recheck the email address entered.')
          setOnRegister(false)
          setIsSend(true)
        // toast.success('Check your email to verify your account.');
      }
      console.log("User created:", response);
    } catch (error) {

    }
  }


  useEffect(() => {
    if (!resumeId) {
      return;
    }

    setPageStateSafe('parsing');
    setProgressMessages([]);
    setPageDataSafe(null);

    let didUnmount = false;
    const unsubscribers = [];

    const handleProgress = (data) => {
      setProgressMessages(prev => prev.includes(data.message) ? prev : [...prev, data.message]);
    };

    const handleSuccess = (data) => {
      handleComplete(data)
    };


    const handleError = (data) => {
      setTimeout(() => {

        if(data.status_code==403){
          toast.warning('User aleady exists with this email. Please login to continue.');
          navigate('/resume-login');
        }
        if (!pageDataRef.current && pageStateRef.current !== 'success' && !didUnmount) {
          setPageStateSafe('error');
        }

      }, 5000);
    };

    const handleComplete = (data) => {
      if(data.candidate_exist && data.user_exist){
        toast.warning('User aleady exists with this email. Please login to continue.');
        navigate('/resume-login');
        return;
      }
      if(isAuthed && !userCandidateId){
        setUserCandidateId(data.candidate_id);
        // handlePageRedirect()
        navigate(`/job-recommendations?candidateId=${data.candidate_id}`, { replace: true });
      }
      console.log("Processing complete:", data);
      setProgressMessages(prev => prev.includes(data.message) ? prev : [...prev, data.message]);

      setCandidateId(data.candidate_id);

      setTimeout(async () => {
        try {
           console.log('called1')
          await getCandidateDetails(data.candidate_id);
          console.log('daaaaa',data)
             setIsLoading(true)
            //  fetAllJobs()
        } catch (err) {
          console.error("Error in completion flow:", err);
          if (!pageDataRef.current) setPageStateSafe('error');
        } finally {
          try {
            webSocketParserService.disconnect();
          } catch (e) {
            console.warn("Disconnect failed:", e);
          }
        }
      }, 1000);
    };

   const handleFailed = (data) => {
  console.warn("Processing failed:", data);
  if(data.status_code==403){
    toast.warning('User aleady exists with this email. Please login to continue.');
    navigate('/resume-login');
  }
  else if(data.status_code==404){
    toast.warning('Email mismatch for candidate.');
    // Keep the previous candidate data and show the page
    if(userCandidateId) {
      // Fetch the existing candidate details to maintain the previous state
      console.log('called 2')
      getCandidateDetails(userCandidateId).then(() => {
        // After successfully fetching, ensure we're showing the profile page
        setShowResumeEditor(false);
      }).catch(err => {
        console.error("Error fetching candidate details after 404:", err);
        setPageStateSafe('error');
      });
    } else {
      // If pageData already exists, just set to success to show it
      if(pageDataRef.current) {
        setPageStateSafe('success');
        setShowResumeEditor(false);
      } else {
        setPageStateSafe('error');
      }
    }
  }
  else{
    if (!pageDataRef.current && pageStateRef.current !== 'success') {
      setPageStateSafe('failed');
      if (!data.email_exist) {
        toast.warning('Please upload a valid resume that includes an email address.');
      } else if (!data.sector_exist) {
        toast.warning('Please upload a resume in the valid sector.');
      } else {
        toast.warning(data.message || 'Unknown error occurred');
      }
    }
  }
};

    // Subscribe
    unsubscribers.push(webSocketParserService.on('progress', handleProgress));
    unsubscribers.push(webSocketParserService.on('success', handleSuccess));
    unsubscribers.push(webSocketParserService.on('error', handleError));
    unsubscribers.push(webSocketParserService.on('complete', handleComplete));
    unsubscribers.push(webSocketParserService.on('failed', handleFailed));

    webSocketParserService.connect(resumeId);

    return () => {
      didUnmount = true;
      console.log("🧹 Cleaning up WebSocket subscriptions...");
      unsubscribers.forEach(unsub => {
        try { unsub(); } catch (e) { console.warn("unsubscribe failed", e); }
      });
      if (pageStateRef.current !== 'success') {
        try {
          webSocketParserService.disconnect();
        } catch (e) {
          console.warn("Error while disconnecting in cleanup:", e);
        }
      }
    };

  }, [resumeId,count]);

  useEffect(() => {
if (!userCandidateId ) {
      return;
    }
    console.log("Fetching candidate details for ID:", userCandidateId );
     handlePageRedirect()

  }, [userCandidateId ]);


const handlePageRedirect=async()=>{
  try {
    console.log('called3')
    await getCandidateDetails(candidateId || userCandidateId);
    console.log('pageData',pageData)
  } catch (error) {
    console.log(error);

  }
}

  const getCandidateDetails = async (id) => {
    console.log('call edit',id)
    const requestBody = {
      candidate_id: id,
      user_payload: {
        request_id: generateRequestId(),
        email: "lakshmi@outlook.com"
      }
    };
    try {
      const response = await resumeUpload.getCandidateDetails(requestBody);
      console.log('candidate details',response)
      if (response && response.success) {
           setIsLoading(true)
           console.log('makecall0')
         fetAllJobs(1,response.data.email)
        const value = {
          profile_details: response.data,
          jobs_recommended: mockApiResponse.jobs_recommended,
          isCandidateExist: false,
          validation:response?.validation

        };
        setSuccessWithData(value);
        if(!response.validation.all_present){
         setShowResumeEditor(true);
        }
      } else {
        if (!pageDataRef.current) setPageStateSafe('error');
      }

    } catch (err) {
      console.error("getCandidateDetails error:", err);
      if (!pageDataRef.current) setPageStateSafe('error');
      throw err;
    }
  };

const fetAllJobs = async(count, email, selection, searchTerm = '') => {
  try {
    console.log('Fetching jobs with search:', searchTerm);
    const screenWidth = window.innerWidth;
    const limitValue = screenWidth >= 1536 ? 16 : 12;

    let payload = {
      user_payload: {
        request_id: generateRequestId(),
        email: email,
        user_id: candidateId || userCandidateId,
        tenant: "ABC"
      },
      page: count || 1,
      limit: limitValue,
      location: selection?.countries ?? filteredCountries,
      sector: selection?.sectors ?? filteredSectors,
      search: searchTerm  // NEW: Add search parameter
    }

    console.log('API payload:', payload);
    let response = await resumeUpload.fetchAlljobs(payload);
    console.log('API response:', response);

    setIsMorePage(response.data.have_more);
    setIsLoading(false);
    setMoreJobs(false);
    setAllUserJobs(response.data.jobs);
     setTotalJobs(response.data.total_jobs || 0);


    // Replace jobs instead of appending when searching
    if (searchTerm || count === 1) {
      setCurrentJobs(response.data.jobs);
    } else {
      setCurrentJobs(prevJobs => [...prevJobs, ...response.data.jobs]);
    }
  } catch (error) {
    console.log(error);
    setIsLoading(false);
  }
}
const handleSearchChange = useCallback((search) => {
  console.log('Search term changed:', search);
  // avoiding duplicate call
  if(isTabApiCalling){
    return
  }else{
  setSearchQuery(search?.term);
  setCurrentJobs([]);  // Clear current jobs
  setPageCount(1);     // Reset to first page
  setIsLoading(true);

  // Call API with search term and current filter selections
  if(search.menu === 'All'){
  if (pageData?.profile_details?.email) {
    console.log('makecall3')
    // Pass the actual filter selections, not filteredJobs
    fetAllJobs(1, pageData.profile_details.email, {
      sectors: filteredSectors,
      countries: filteredCountries
    }, search.term);
  }
  }else if(search.menu === 'Recommended'){
     fetchRecommendedJobs(1, search?.term);
  }
  }


}, [pageData?.profile_details?.email, filteredSectors, filteredCountries,isTabApiCalling]); // Add dependencies

    const fetchAppliedJobs=async()=>{
    try {
            setCurrentJobs([])
      setIsLoading(true)
      let payload={
    candidate_id:userCandidateId,
    user_payload: {
        request_id: generateRequestId(),
        user_id:user.id
    }

}
      let response=await resumeUpload.fetchAppliedjobs(payload)
         setIsLoading(false)
      console.log('applied jobs',response)
      setAppliedJobs(response.data)
      setCurrentJobs(response.data)
       setTotalJobs(response.total || 0);
    } catch (error) {
      console.log(error)
    }
  }


      const fetchRecommendedJobs = async (page = 1,searchTerm = '') => {
        try {
            if (page === 1) {
      setCurrentJobs([]);
      setIsLoading(true); // Full page loader for first load
    } else {
      setMoreJobs(true); // Bottom spinner for lazy loading
    }
      const screenWidth = window.innerWidth;
      const limitValue = screenWidth >= 1536 ? 16 : 12;
          let payload = {
            user_payload: {
              request_id: generateRequestId(),
              user_id: parseInt(user.id),
            },
            page: page,
            limit: limitValue,
            search: searchTerm,
            candidate_id: parseInt(userCandidateId),
          };
          console.log("pay", payload);
          let response = await resumeUpload.fetchRecommendedjobs(payload);
          setIsLoading(false);
          
          console.log("recommended jobs", response);
          if (response?.data?.jobs) {
            setTotalJobs(response.data.total_jobs || 0);
             setIsMorePage(response.data.have_more);

               if (page === 1) {
        setCurrentJobs(response.data.jobs);
      } else {
        setCurrentJobs(prevJobs => [...prevJobs, ...response.data.jobs]);
      }
          } else {
            setCurrentJobs([]);
          }
        } catch (error) {
          console.log(error);
        }
        finally { 
        setIsLoading(false);
        setMoreJobs(false);
      };
    }

const getMenu =  async(item) => {
  try {
    setIsTabApiCalling(true)
    setCurrentMenu(item);
    setCurrentJobs([]);
    setSearchQuery('');  // Reset search query
    console.log('menu', item);

    if (item === 'All') {
      setIsLoading(true);
      setTotalJobs(0);
      console.log('makecall1')
      await fetAllJobs(1, pageData.profile_details.email);
      setIsTabApiCalling(false)
    } else if (item === 'Applied') {
        setTotalJobs(0);
      await fetchAppliedJobs();
      setIsTabApiCalling(false)
    } else if (item === 'Recommended') {
       setTotalJobs(0);
       await fetchRecommendedJobs(1, '');
       setIsTabApiCalling(false)
    }
  } catch (error) {
    console.log(error);
  }
}

  useEffect(() => {
    if (pageState === 'error' || pageState === 'failed') {
      const redirectTimer = setTimeout(() => {
        if (pageStateRef.current !== 'success') {
          navigate(`/profiler`);
        }
      }, 5000);
      return () => clearTimeout(redirectTimer);
    }
    return undefined;
  }, [pageState, navigate]);

  //   useEffect(() => {
  //   if (pageData && pageData.profile_details) {
  //     setCompletionPercentage(calculateCompletionPercentage(pageData.profile_details));
  //   }
  // }, [pageData]);

  useEffect(() => {
    if (pageData && pageData.profile_details) {
      // setCompletionPercentage(calculateCompletionPercentage(pageData.profile_details));
        const fullReport = calculateCompletionPercentage(pageData.profile_details);
      setCompletionPercentage(fullReport.percentage); 
    }
  }, [pageData]);

  const handleViewAndUpdateResume = async () => {
    console.log("Viewing and updating resume for candidateId:",);
     console.log('called4')
    await getCandidateDetails(candidateId || userCandidateId);

    setShowResumeEditor(true);
  };

const uploadFile = async (file) => {
  const response = await resumeUpload.resumeUpdate({
    'files': [file],
    'user_payload': {
      'request_id': generateRequestId()
    }
  });
  console.log('upload response', response)
  console.log(response)
  if (response.status == 'Success') {
    setCount(prev => prev + 1);
    console.log('upload response', response)
    setResumeId(response.data.doc_id[0])
    // Reset state to show parsing progress
    setPageStateSafe('parsing');
    setProgressMessages([]);
    setPageDataSafe(null);
    setShowResumeEditor(false); // Close the editor to show parsing view
  } else {
    toast.warning(response.message )
    // setError(response.message);
    // setSelectedFile(null);
  }
}


  const handleSelectionChange = (selections) => {
    console.log('Selection changed:', selections);
    setFilteredJobs(selections)
    setFilteredCountries(selections.countries);
    setFilteredSectors(selections.sectors); 
      setIsLoading(true)
      setCurrentJobs([]);
      setAllUserJobs([]);
       console.log('makecall2')
        fetAllJobs(1,pageData.profile_details.email,selections, searchQuery)
    console.log('Sectors:', selections);
    console.log('Countries:', selections);
  };

  const handleResumeEditorBack = () => {
    setCurrentJobs([]);
     console.log('makecall4')
        setIsLoading(true)
        fetAllJobs(1,pageData.profile_details.email)
    setShowResumeEditor(false);
  };
  const renderProfilePage = () => {
    if (!pageData || !pageData.profile_details) {
      return <Loader message="Loading" />
    }
    return (
      <div className="flex flex-col lg:flex-row gap-8 items-start h-[calc(100vh-8rem)]">
        {/* <Sidebar
          profileDetails={pageData.profile_details}
          showActivity={pageData.isCandidateExist}
          onViewAndUpdateResume={handleViewAndUpdateResume}
          completionPercentage={completionPercentage}
        /> */}
      <JobList jobs={currentJobs} candidateId={userCandidateId} resumecandidate={candidateId} isLoading={isLoading} onApplyJob={onApplyJob} onMenuChange={(value) => getMenu(value)} onPageChange={(value)=>handleCountChange(value)}   onSearchChange={handleSearchChange}  isValidate={pageData.validation.all_present} isMore={isMorePage} applyingJobId={applyingJobId} sectors={allSectors} countries={allCountries} onSelectionChange={handleSelectionChange} totalJobs={totalJobs} />
      </div>
    );
  };

  const renderContent = () => {
    if (showResumeEditor) {
      return <ProfilerEditingPage candidateId={candidateId || userCandidateId} userCandidateId={userCandidateId} onBack={handleResumeEditorBack} profileDetails={pageData?.profile_details} completionPercentage={completionPercentage} uploadedFile={uploadFile} />;
    }
    if (pageState === 'success') {
      return renderProfilePage();
    }

    if (pageState === 'error' || pageState === 'failed') {
      return <ParsingProgressView messages={[]} warning={'There was an issue processing your resume. You will be redirected shortly.'} title={'Redirecting...'} />
    }
    return <ParsingProgressView messages={progressMessages} title={'Analyzing Your Profile...'} />;
  };

  useEffect(() => {
    console.log("pageState:", pageState, "pageData:", pageData, "showResumeEditor:", showResumeEditor);
  });
  const closeModal=()=>{
    try {
      setIsRegister(false)
      setOnRegister(false)
      setIsSend(false)
      setRegistrationPassword('')
      setRegistrationPasswordConfirm('')
      setPasswordError('')
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (!showResumeEditor && window.__SHOW_PROFILE_PAGE__) {
      setTimeout(() => {
        window.__SHOW_PROFILE_PAGE__ = false;
      }, 0);
    }
  }, [showResumeEditor]);

  const handleBackFromResumeEditor = () => {
    setCurrentJobs([]);
     console.log('makecall5')
        setIsLoading(true)
    fetAllJobs(1,pageData.profile_details.email)
    window.__SHOW_PROFILE_PAGE__ = true;
    setShowResumeEditor(false);
  };



  return (
    <div className="main-background overflow-y-auto flex-flex-col gap-2 min-h-screen">
      <ProfilerNavBar status={pageState} userCandidateId={userCandidateId} profileDetails={pageData?.profile_details}  userData={pageData}  completionPercentage={completionPercentage} handleViewAndUpdateResume={handleViewAndUpdateResume} />
      <main className="container mx-auto pt-24 px-8 pb-8">
        {showResumeEditor
          ? <ProfilerEditingPage candidateId={candidateId || userCandidateId} userCandidateId={userCandidateId} onBack={handleBackFromResumeEditor} profileDetails={pageData?.profile_details} fullData={pageData}  completionPercentage={completionPercentage} onedit={(value)=>getCandidateDetails(value)} uploadedFile={uploadFile} />
          : (window.__SHOW_PROFILE_PAGE__ && pageState === 'success'
            ? renderProfilePage()
            : renderContent()
          )
        }
        {moreJobs&&(
        <div className='w-full mt-0.5 flex items-center justify-center gap-2 text-xs font-semibold' ><div className='jobloader'></div>Loading jobs...</div>
        )}
        </main>

         {isregister&&(
      <div className='absolute top-0 flex items-center justify-center left-0 z-100 w-full h-full bg-[#C9C9C959]'>
        <div class="modal">
          {!onregister && !isSend &&(
          <div>
            <div class="modal-icon">
                <svg fill="none" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"/>
                </svg>
            </div>
            <div class="modal-message">
              {modalMessage}
            </div>
            <div className="w-full px-6 py-4">
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">Password</label>
                <input 
                  type="password" 
                  value={registrationPassword}
                  onChange={(e) => setRegistrationPassword(e.target.value)}
                  placeholder="Enter password (min. 8 characters)"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">Confirm Password</label>
                <input 
                  type="password" 
                  value={registrationPasswordConfirm}
                  onChange={(e) => setRegistrationPasswordConfirm(e.target.value)}
                  placeholder="Confirm password"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              {passwordError && (
                <div className="text-red-600 text-sm mb-4">{passwordError}</div>
              )}
            </div>
            <div class="modal-buttons items-center justify-center ">
                <button onClick={()=>closeModal()} class="modal-btn  px-2 py-1 btn-cancel">Cancel</button>
                <button onClick={()=>createUser()} class="modal-btn  px-2 py-1 btn-ok" >Continue</button>
            </div>
            </div>
            )}
            {onregister  && !isSend && (
          <div>
            <div className=' w-full flex items-center justify-center p-2'>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="150px"
        height="60px"
        viewBox="0 180 400 150"
        style={{
          fill: 'white',
          stroke: '#B2853D',
          strokeWidth: '4',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
      >
        <defs>
          <style>{`
            @keyframes windDash {
              to {
                stroke-dashoffset: -60;
              }
            }

            #wind line {
              animation: windDash 0.5s linear infinite;
            }
          `}</style>
        </defs>

        <g id="wind">
          <line x1="119" y1="215.37" x2="49" y2="215.37" strokeDasharray="17,15,15,13"/>
          <line x1="119" y1="231.34" x2="18" y2="231.34" strokeDasharray="19,15,15,11"/>
          <line x1="119" y1="247.3" x2="26" y2="247.3" strokeDasharray="13,19,15,13"/>
          <line x1="119" y1="263.26" x2="2" y2="263.26" strokeDasharray="20,14,10,16"/>
          <line x1="119" y1="279.23" x2="65" y2="279.23" strokeDasharray="13,15,11,21"/>
        </g>

        <g id="envelope">
          <path d="M262.09,288.8H144.12c-4.43,0-8.02-3.59-8.02-8.02v-66.97c0-4.43,3.59-8.02,8.02-8.02h58.98h58.98c4.43,0,8.02,3.59,8.02,8.02v66.97C270.11,285.21,266.52,288.8,262.09,288.8z"/>
          <path d="M136.02,275.14l36.27-24.58c3.61-2.45,7.88-3.76,12.24-3.76h37.16c4.37,0,8.63,1.31,12.24,3.76l36.27,24.58"/>
          <line x1="270.2" y1="225.65" x2="233.93" y2="250.6"/>
          <line x1="172.28" y1="250.6" x2="136.02" y2="225.65"/>
          <path
            id="lid"
            vectorEffect="non-scaling-stroke"
            strokeWidth="2"
            d="M270.2,213.39v7.01c0,3.36-1.76,6.56-4.82,8.71l-53.87,38.12c-4.86,3.44-11.95,3.44-16.82,0l-53.87-38.12c-3.05-2.16-4.82-5.35-4.82-8.71v-7.01"
          />
        </g>
      </svg>
            </div>
            <div class="modal-message">
              Sending verification request..
            </div>
            </div>
            )}
           {isSend&&(
              <div>
            <div>
            <div class="w-full flex items-center justify-center pb-6">
                <div class="success-circle">
                    <svg class="success-checkmark" viewBox="0 0 52 52">
                        <path class="checkmark-path" d="M14 27l10 10 20-20"/>
                    </svg>
                </div>
            </div>
            </div>
            <div class="modal-message">
              {modalMessage}
            </div>
            <div class="modal-buttons items-center justify-center ">
                <button onClick={()=>closeModal()} class="modal-btn  px-3 py-2 btn-ok" >ok</button>
            </div>
            </div>
           )}


        </div>
      </div>
      )}
    </div>
  );
}

export default JobRecommendationsPage;